import { httpClient } from '../../services/http-client'
import { RegistrationData, FederatedLoginData, ResetPaswordConfirmationData } from '../../models/auth-dto'

class AuthApi {
    login(email: string, password: string) {
        return httpClient
            .post('/auth/login/', { email, password })
            .then(res => {
                return res.data.token as string
            })
    }

    federatedLogin(loginData: FederatedLoginData) {
        return httpClient
            .post('/auth/federatedLogin/', loginData)
            .then(res => {
                return res.data.token as string
            })
    }

    impersonate(email: string) {
        return httpClient
            .post('/auth/impersonate/', {email})
            .then(res => {
                return res.data.token as string
            })
    }

    register(registrationData: RegistrationData) {
        return httpClient.post('/auth/register/', registrationData)
    }

    resendConfirmationEmail(email: string) {
        return httpClient.post('/auth/resendConfirmEmail/', { email })
    }

    confirmPasswordReset(data: ResetPaswordConfirmationData) {
        return httpClient.post('/auth/confirmResetPassword/', data)
    }

    forgotPassword(email: string) {
        return httpClient.post('/auth/forgotPassword/', { email })
    }

    resetPassword(userId: number, data: ResetPaswordConfirmationData) {
        return httpClient.post(`/auth/resetPwd?userId=${userId}`, data)
    }

    refreshAccessToken() {
        return httpClient.post(`/auth/refreshAccessToken`).then(res => {
            return res.data.token as string
        }).catch(error => {
            return ''
        })
    }

    revokeRefreshToken() {
        return httpClient.post(`/auth/revokeRefreshToken`).catch(error => {
            return
        })
    }
}

export const authApi = new AuthApi()
